// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__cpX7h","icon":"BackButton_icon__T0UiF"};